// extracted by mini-css-extract-plugin
module.exports = {"title":"Stats_title__2foHk","flex1":"Stats_flex1__1S5W_","topText":"Stats_topText__3IB2a","root":"Stats_root__1uzbU","row":"Stats_row__2F4rG"};